import React from "react";
import { Button, Dropdown, Form } from "react-bootstrap";
import { runInnerFunction } from "../../compatManager";
import { LocalYearMonthDayHourMinuteString } from "../fileToolbarFuncs";
import { DropdownArrayObj } from "../fileToolbarConsts";
import { getDataReader } from "../../livedataFuncs";
import DropdownToggle from "../../Components/DropdownToggle";

export interface IProps {
    index: number,
    subIndex?: number,
    text: string,
    setEditFlag: (editFlag: boolean) => void,
    noteDropdownState?: string,
    dataRoot?: any,
    category?: string
}

interface IState {
    initials: string,
    boxText: string,
    noteType: string,
}

export type RightMenuEditTextAreaType = {
    text: string,
}

export class RightMenuEditTextArea extends React.Component<IProps, IState>{
    constructor(props: IProps) {
        super(props);

        // const initialNoteType = props.noteDropdownState === 'All'
        // ? 'General'
        // : this.getKeyByValue(DropdownArrayObj.mainScreenNameIndex, props.noteDropdownState) || props.noteDropdownState;
        const initialNoteType = DropdownArrayObj.mainScreenNameVals[this.props.category];

        this.state = {
            boxText: props.text,
            initials: '',
            noteType: initialNoteType,
        }
        
    }
    setTextbox = (text: string) => {
        this.setState({
            boxText: text
        })
    }

    handleDropdownSelect = (selectedType: string) => {
        this.setState({
            noteType: selectedType
        });
    }

    getKeyByValue = (object: any, value: string) => {
        return Object.keys(object).find(key => object[key] === value);
    }
    render(): React.ReactNode {
        let UTCDateHolder = LocalYearMonthDayHourMinuteString();
        return (
            <>
                {this.props.noteDropdownState === 'All' && (
                    <>
                        <Dropdown onSelect={this.handleDropdownSelect}>
                            <Dropdown.Toggle as={DropdownToggle}>
                                {this.state.noteType}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                {Object.keys(DropdownArrayObj.mainScreenNameIndex).filter(option => option !== 'All').map(option => (
                                    <Dropdown.Item key={option} eventKey={option}>
                                        {option}
                                    </Dropdown.Item>
                                ))}
                            </Dropdown.Menu>
                        </Dropdown>
                    </>
                )}
                
                <Form.Control as="textarea"
                    cols={30} defaultValue={this.props.text}
                    onChange={(event) => this.setTextbox(event.target.value)}
                >
                </Form.Control>

                <div className="note-toolbar">                
                    <Button variant="link" size="sm"
                        onClick={() => {
                            this.props.setEditFlag(false);
                        }
                        }
                    >
                        Cancel
                    </Button>

                    <Button variant="primary" size="sm"
                        onClick={() => {
                            try {
                                let paramArray: string[] = [this.state.boxText, UTCDateHolder, '' + this.props.index, '' + this.props.subIndex];
                                if (this.props.dataRoot && this.props.noteDropdownState === "All") {
                                    const DataReaderObj = getDataReader(this.props.dataRoot);
                                    const noteTypeKey = this.getKeyByValue(DropdownArrayObj.mainScreenNameVals, this.state.noteType);
                                    if (noteTypeKey) {
                                        DataReaderObj.setNoteMainScreenName(noteTypeKey, this.props.index);
                                    }
                                }
                                runInnerFunction('reactChangeNoteText', paramArray);
                                this.props.setEditFlag(false);
                            } catch (e) {
                                console.log(e);
                            }
                        }}
                    ><i className="fa-solid fa-check"></i></Button>
                </div>
            </>
        );
    }
}